const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

async function parseErrorMessage(res) {
  try {
    const data = await res.json();
    return data.detail || data.message || `Request failed (${res.status})`;
  } catch (e) {
    return `Request failed (${res.status})`;
  }
}

export async function createDonationCheckout(amount) {
  const res = await fetch(`${API}/payments/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, origin_url: window.location.origin }),
  });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // { checkout_url, session_id }
}

export async function getPaymentStatus(sessionId) {
  const res = await fetch(`${API}/payments/status/${sessionId}`);
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // { session_id, status, payment_status }
}
